/**
 * Contrats de maintenance et propositions (onglet Contrats de la rubrique
 * Ventes). Lecture sous `contract.view`, saisie sous `contract.manage` ; les
 * propositions demandent aussi `pricing.view_sale_prices` ; le serveur vérifie
 * chaque route. Les propositions gardent leurs adresses historiques (avis,
 * signets) ; leur liste est l'onglet « Propositions ».
 */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';

const ContractsPage = lazy(() => import('./ContractsPage.js').then((m) => ({ default: m.ContractsPage })));
const ContractDetailPage = lazy(() => import('./ContractDetailPage.js').then((m) => ({ default: m.ContractDetailPage })));
const ContractNewPage = lazy(() => import('./ContractFormPages.js').then((m) => ({ default: m.ContractNewPage })));
const ContractEditPage = lazy(() => import('./ContractFormPages.js').then((m) => ({ default: m.ContractEditPage })));
const ContractAmendPage = lazy(() => import('./ContractFormPages.js').then((m) => ({ default: m.ContractAmendPage })));
const ContractFromProposalPage = lazy(() => import('./ContractFormPages.js').then((m) => ({ default: m.ContractFromProposalPage })));
const ProposalDetailPage = lazy(() => import('./ProposalPages.js').then((m) => ({ default: m.ProposalDetailPage })));
const ProposalNewPage = lazy(() => import('./ProposalPages.js').then((m) => ({ default: m.ProposalNewPage })));
const ProposalEditPage = lazy(() => import('./ProposalPages.js').then((m) => ({ default: m.ProposalEditPage })));
const MaintenanceProposalEmailPage = lazy(() => import('./MaintenanceProposalEmailPage.js').then((m) => ({ default: m.MaintenanceProposalEmailPage })));

const view = { anyOf: ['contract.view'] } as const;
const manage = { anyOf: ['contract.manage'] } as const;
// Une proposition est une simulation chiffrée : elle demande aussi les prix de vente (Q82, 18/10/2026).
const priced = { allOf: ['pricing.view_sale_prices'] } as const;

export const contractsRoutes: AppRoute[] = [
  { path: '/contrats', element: <ContractsPage />, gate: view },
  { path: '/contrats/nouveau', element: <ContractNewPage />, gate: manage },
  { path: '/contrats/:id', element: <ContractDetailPage />, gate: view },
  { path: '/contrats/:id/modifier', element: <ContractEditPage />, gate: manage },
  { path: '/contrats/:id/avenant', element: <ContractAmendPage />, gate: manage },
  { path: '/propositions-maintenance', element: <ContractsPage />, gate: { ...view, ...priced } },
  { path: '/propositions-maintenance/nouvelle', element: <ProposalNewPage />, gate: { ...manage, ...priced } },
  { path: '/propositions-maintenance/:proposalId', element: <ProposalDetailPage />, gate: { ...view, ...priced } },
  { path: '/propositions-maintenance/:proposalId/modifier', element: <ProposalEditPage />, gate: { ...manage, ...priced } },
  { path: '/propositions-maintenance/:proposalId/contrat', element: <ContractFromProposalPage />, gate: { ...manage, ...priced } },
  { path: '/propositions-maintenance/:proposalId/envoyer', element: <MaintenanceProposalEmailPage />, gate: { ...manage, ...priced } },
];
